/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-01-19 10:00:14
 *
 *******************************************************/
// @flow

import type {
  AddOptionEmailState,
  AddOptionEmailAction
} from 'stores/flow-type/dashboard/option-email.type';

import {
  ADD_OPTION_EMAIL_REQUEST,
  ADD_OPTION_EMAIL_SUCCESS,
  ADD_OPTION_EMAIL_FAILURE
} from 'stores/flow-type/dashboard/option-email.type';

const initialState: AddOptionEmailState = {
  loading: false,
  success: false,
  error: undefined,
  data: null
};

const OptionEmailReducers = (
  state: AddOptionEmailState = initialState,
  action: AddOptionEmailAction
) => {
  switch (action.type) {
    case ADD_OPTION_EMAIL_REQUEST:
      return { ...state, loading: true };
    case ADD_OPTION_EMAIL_SUCCESS: {
      const { data } = action.payload;
      return { ...state, loading: false, success: true, data };
    }
    case ADD_OPTION_EMAIL_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      };
    default:
      return state;
  }
};

export default OptionEmailReducers;
